module.exports = __webpack_public_path__ + "static/media/ar21_ldisbrow.4448eb7e.jpeg";